import { Effect, Reducer } from 'umi';
import moment from 'moment';

const namespace = 'opinionFeedsFilter';

type stateType = any;

const customModel: {
  effects: {};
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    channel: [],
    language: [],
    keyword: [],
    region: [],
    region_type: 'region',
    start_time: moment()
      // .subtract(7, 'days')
      .startOf('D')
      .format('yyyy-MM-DD HH:mm:ss'),
    end_time: moment().endOf('D').format('yyyy-MM-DD HH:mm:ss'),
    date_type: 'daily',
  },
  reducers: {
    save(state: stateType, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {},
};

export default customModel;
